import api from './api';
import { Profile, ProfileFormData, Permission, ApiResponse } from '../types';
import { HmgRole } from '../types';

export const profileService = {
  async getAll(): Promise<Profile[]> {
    // Usar rota /hmg/roles que retorna os perfis de acesso
    const response = await api.get<HmgRole[]>('/hmg/roles');
    // Mapear HmgRole para Profile mantendo compatibilidade
    return response.data.map((role: HmgRole) => ({
      id: role.id,
      name: role.name,
      nome: role.name,
      description: role.description,
      descricao: role.description,
      is_active: role.is_active,
      active: role.is_active,
    }));
  },

  async getById(id: number): Promise<Profile> {
    const response = await api.get<HmgRole>(`/hmg/roles/${id}`);
    const role = response.data;
    return {
      id: role.id,
      name: role.name,
      nome: role.name,
      description: role.description,
      descricao: role.description,
      is_active: role.is_active,
      active: role.is_active,
    };
  },

  async create(data: ProfileFormData): Promise<Profile> {
    const response = await api.post<HmgRole>('/hmg/roles', {
      name: data.name || data.nome,
      description: data.description || data.descricao,
      is_active: data.is_active ?? data.active ?? true,
    });
    const role = response.data;
    return {
      id: role.id,
      name: role.name,
      nome: role.name,
      description: role.description,
      descricao: role.description,
      is_active: role.is_active,
      active: role.is_active,
    };
  },

  async update(id: number, data: ProfileFormData): Promise<Profile> {
    const response = await api.put<HmgRole>(`/hmg/roles/${id}`, {
      name: data.name || data.nome,
      description: data.description || data.descricao,
      is_active: data.is_active ?? data.active ?? true,
    });
    const role = response.data;
    return {
      id: role.id,
      name: role.name,
      nome: role.name,
      description: role.description,
      descricao: role.description,
      is_active: role.is_active,
      active: role.is_active,
    };
  },

  async delete(id: number): Promise<void> {
    await api.delete(`/hmg/roles/${id}`);
  },

  async getPermissions(): Promise<Permission[]> {
    const response = await api.get<Permission[]>('/hmg/permissions');
    return response.data || [];
  },

  async syncPermissions(profileId: number, permissionIds: number[]): Promise<void> {
    await api.post(`/hmg/roles/${profileId}/permissions/sync`, {
      permission_ids: permissionIds,
    });
  },
};
